export default __webpack_public_path__ + "static/media/icons-file.19fcbb99.svg";